// stores/storeClientSource.js
import { defineStore } from 'pinia'

export const useStoreClientSource = defineStore('storeClientSource', {
    state: () => {
        return {
            clientSource: null
        }
    },
    actions: {
        saveClientSource(newClientSource) {
            this.clientSource = newClientSource;
        },
    },
    getters: {
        getClientSource: (state) => {
            return () => {
                return state.clientSource
            }
        },
    },
    persist: true,
})
